import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from './components/login';
import HomePage from './components/home';
import Upload from './components/upload';
import FolderView from './components/folderView';
import Editor from './components/editor';
import TemplateEditor from './components/template';
import ImageList from './components/imageList';
import VideoList from './components/videolist';
import StoryJourney from './components/storyJourney';
import PrivacyPolicy from './components/privacypolicy';
import TermsOfService from './components/termsOfService';
import Blog from './components/blog';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/signin" element={<Login />} />
        <Route path="/upload" element={<Upload />} />
        <Route path="/folder/:folderName" element={<FolderView />} />
        <Route path="/editor" element={<Editor />} />
        <Route path="/template" element={<TemplateEditor />} />
        <Route path="/images/:folderName" element={<ImageList />} />
        <Route path="/videos/:folderName" element={<VideoList />} />
        <Route path="/journey/:id" element={<StoryJourney />} />
        <Route path="/privatepolicy" element={<PrivacyPolicy />}/>
        <Route path="/termsOfService" element={<TermsOfService />}/>
        <Route path="/blog" element={<Blog />}/>
      </Routes>
    </Router>
  );
}

export default App;
